export class TextBuilder {
  constructor(initial = '') {
    this.text = initial;
  }

  addText(text, cond = true) {
    if (!cond) return this;
    this.text += text;
    return this;
  }

  addStyledText(text, style, cond = true) {
    if (!cond) return this;
    if (style) {
      const styleStr = Object.entries(style).map(item => item.join(':')).join(';');
      text = `<span style="${styleStr}">${text}</span>`;
    }
    this.addText(text, cond);
    return this;
  }

  addLine(text, cond = true) {
    if (!cond) return this;
    this.text += `${text}\n`;
    return this;
  }

  toString() {
    return this.text.trim();
  }
}
